const organizations = require("./Organizations-einander-helfen.csv");

export default organizations;
